import { Modal as AntModal } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './modal.module.scss';
import { Button } from '../button/button';

type ModalProps = {
  onCancel: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  isExporting?: boolean;
  confirmText?: string;
  cancelText?: string;
};

export function Modal({
  onCancel,
  onConfirm,
  isOpen,
  isExporting,
  title,
  children,
  confirmText,
  cancelText,
}: ModalProps) {
  const { t } = useTranslation('common');

  return (
    <AntModal
      className={styles.modal}
      title={title}
      open={isOpen}
      onOk={onConfirm}
      onCancel={onCancel}
      footer={
        <div className={styles.footer}>
          <Button buttonVariant="secondary" className={styles.modalButton} onClick={onCancel}>
            {cancelText ?? t('actions.close')}
          </Button>
          <Button
            loading={isExporting}
            buttonVariant="primary"
            className={styles.modalButton}
            onClick={onConfirm}
          >
            {confirmText ?? t('actions.export')}
          </Button>
        </div>
      }
    >
      {children}
    </AntModal>
  );
}
